<template>
  <div class="c-info-wizard" :class="{ 'c-info-wizard--visible': isVisible }">
    <div class="c-info-wizard__window">
      <div class="c-info-wizard__slides">
        <div
          class="c-info-wizard__slide"
          :class="`c-info-wizard__slides--active-${activeSlide}`"
          v-for="(slide, index) in slides"
          :key="`slide${index}`"
        >
          <iframe class="c-info-wizard__frame" :src="slide" />
        </div>
      </div>
      <div class="c-info-wizard__dots">
        <div
          class="c-info-wizard__dot"
          :class="{ 'c-info-wizard__dot--active': index === activeSlide }"
          v-for="index in slides.length"
          :key="`dot${index}`"
        />
      </div>
      <div class="c-info-wizard__check">
        <o-checkbox :checked="true">Don't show next time</o-checkbox>
      </div>
      <div class="c-info-wizard__buttons">
        <o-button @click="hideWizard" label="Overslaan" />
        <o-button @click="nextSlide" :is-primary="true" label="Volgende" />
      </div>
    </div>
  </div>
</template>

<script>
import OButton from '@/components/base/OButton.vue'
import OCheckbox from '@/components/base/OCheckbox.vue'
export default {
  name: 'OInfoWizard',
  components: { OCheckbox, OButton },
  props: {
    slides: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isVisible: true,
    activeSlide: 1
  }),
  computed: {
    lastSlide() {
      return this.activeSlide === this.slides.length
    }
  },
  methods: {
    hideWizard() {
      this.isVisible = false
    },
    nextSlide() {
      if (!this.lastSlide) {
        this.activeSlide = this.activeSlide + 1
      } else {
        this.hideWizard()
        this.activeSlide = 1
      }
    }
  }
}
</script>

<style lang="scss">
.c-info-wizard {
  background: rgba(#000, 0.4);
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.2s linear;
  z-index: 20;
}

.c-info-wizard--visible {
  opacity: 1;
  pointer-events: auto;
}

.c-info-wizard__window {
  background: #fff;
  border-radius: $border-radius;
  box-shadow: $box-shadow-large;
  bottom: 2.4rem;
  display: flex;
  flex-direction: column;
  left: 2.4rem;
  overflow: hidden;
  position: absolute;
  right: 2.4rem;
  top: 2.4rem;
}

.c-info-wizard__slides {
  display: flex;
  flex: 1 1 0;
  overflow: hidden;
}

@for $i from 2 to 5 {
  .c-info-wizard__slides--active-#{$i} {
    transform: translateX(#{-100% * ($i - 1)});
  }
}

.c-info-wizard__slide {
  flex: none;
  height: 100%;
  position: relative;
  width: 100%;
}

.c-info-wizard__frame {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.c-info-wizard__dots {
  display: flex;
  justify-content: center;
  padding: 2.4rem 0 0.8rem;
}

.c-info-wizard__dot {
  background: $gray-100;
  border-radius: 50%;
  flex: none;
  height: 0.6rem;
  margin: 0 0.4rem;
  width: 0.6rem;
}

.c-info-wizard__dot--active {
  background: $primary-color;
  background: var(--primary-color);
}

.c-info-wizard__check {
  padding: 0 1.6rem 0.8rem;
}

.c-info-wizard__buttons {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 1.6rem 1.6rem;

  & > * + * {
    margin-top: 0 !important;
  }
}
</style>
